import { oneLine } from 'common-tags';
import React, { useEffect } from 'react';
import DataTable  from 'react-data-table-component';
import TablesActions from './TablesActions';
import referralUsers from 'api/referral/users'
import Dinero from 'dinero.js';
import { format } from 'date-fns';
import NoDataTable from './NoDataTable';
import PulseLoader from 'react-spinners/PulseLoader';

type IProps = {
  count?: number;
};

const Tables: React.FC<IProps> = (count) => {

  const lineContainerClasses = oneLine`
    flex flex-col justify-start
    h-full line-container
  `;

  const valueClasses = oneLine`
    text-sm
    text-white
    h-full 
    flex items-center
    w-full  
    flex-row 
    justify-start 
    flex-wrap
    line-container
  `;

  const getStatusClases = (status: string) => {
    if(status === "Inactive") {
      return 'text-primarydark-default bg-primarydark-default bg-opacity-20 rounded-2xl px-4 py-1'
    } else {
      if (status === 'pending') {
        return 'text-warn-500 bg-warn-default bg-opacity-20 rounded-2xl px-4 py-1'
      } else {
        if (status === 'denied'){
          return 'text-danger-500 bg-danger-500 bg-opacity-20 rounded-2xl px-4 py-1'
        } else {
          return 'text-success-500 bg-success-500 bg-opacity-20 rounded-2xl px-4 py-1'
        }
      }
    }
  }

  const [tablesList, setTablesList] = React.useState<any[]>([
    { 
      value: 'transactions', 
      icon: '', 
      label: 'Balance', 
      checked: true,
      pagination: {
        limit: 10,
        skip: 0,
      },
      sort: {
        order_by:'',
        order_type: ''
      },
      filter: {
        filter_by: '',
        filter_value: ''
      }
    },
    { 
      value: 'users', 
      icon: '', 
      label: 'Users', 
      checked: false,
      pagination: {
        limit: 10,
        skip: 0,
      },
      sort: {
        order_by:'',
        order_type: ''
      },
      filter: {
        filter_by: '',
        filter_value: ''
      }
    },
    { 
      value: 'financials', 
      icon: '', 
      label: 'Withdraws', 
      checked: false,
      pagination: {
        limit: 10,
        skip: 0,
      },
      sort: {
        order_by:'',
        order_type: ''
      },
      filter: {
        filter_by: '',
        filter_value: ''
      }
    },
  ]);

  const [columns, setColumns] = React.useState<any[]>([]);
  const [tableData, setTableData] = React.useState<any[]>([]);
  const [selectedTable, setSelectedTabel] = React.useState<string>('');
  const [usersTable, setUsersTable] = React.useState<any[]>([]);
  const [financialsTable, setFinancialsTable] = React.useState<any[]>([]);
  const [statusUsers, setStatusUsers] = React.useState<any>({});
  const [transactionsTable, setTransactionsTable] = React.useState<any[]>([]);
  const [totalRowsTrans, setTotalRowsTrans] = React.useState<number>(0);
  const [totalRowsUsers, setTotalRowsUsers] = React.useState<number>(0);
  const [totalRowsFinancials, setTotalRowsFinancials] = React.useState<number>(0);
  const [usedFilters, setUsedFilters] = React.useState<boolean>(false);
  const [loader, setLoader] = React.useState<boolean>(true);

  React.useEffect(() => {
    getTablesData();
  }, [tablesList])

  React.useEffect(() => {
    getTransactions();
    getFinancials();
  }, [count])

  React.useEffect(() => {
    if(selectedTable === '') {
      const defaultSelectedTable = tablesList.filter(table => table.checked === true)
      setDisplayType(defaultSelectedTable[0]?.value || tablesList[0].value);
    } else {
      setDisplayType(selectedTable);
    }
  }, [usersTable, transactionsTable, financialsTable])

  const getTablesData = async () => {
    if(selectedTable === '' || selectedTable === 'transactions') {
      getTransactions();
    }
    if(selectedTable === '' || selectedTable === 'users') {
      getUsers();
    }
    if(selectedTable === '' || selectedTable === 'financials') {
      getFinancials();
    }
  }

  const getTransactions = async () => {
    const responseTransactions = await referralUsers.getReferralTransactionsData(tablesList[0].sort, tablesList[0].filter, tablesList[0].pagination);
    setTransactionsTable(responseTransactions.data);
    setTotalRowsTrans(responseTransactions.totalRows);
    setLoader(false);
  }
  const getUsers = async () => {
    const responseUsers = await referralUsers.getRefereesData(tablesList[1].sort, tablesList[1].filter, tablesList[1].pagination);
    setUsersTable(responseUsers.data);
    setTotalRowsUsers(responseUsers.totalRows);
    setStatusUsers(responseUsers.status)
    setLoader(false);
  }
  const getFinancials = async () => {
    const responseUsers = await referralUsers.getFinancialsData(tablesList[2].sort, tablesList[2].filter, tablesList[2].pagination);
    setFinancialsTable(responseUsers.data);
    setTotalRowsFinancials(responseUsers.totalRows);
    setLoader(false);
  }

  const columnsTransactions : any[] = [
    {
      name: 'Actions',
      selector: 'actions',
      sortable: false,
      accessor: 'actions',
      cell: (props: any) => (
        <div className={lineContainerClasses}>
          <div
            className={valueClasses}
          >
            <h1 className="col-label-mobile">Action:</h1>
            {props.actions}
          </div>
        </div>
      ),
    },
    {
      name: 'Amount',
      selector: 'transaction_value',
      sortable: true,
      cell: (props: any) => (
        <div className={lineContainerClasses}>
          <div className={valueClasses}
          >
            <h1 className="col-label-mobile">Amount:</h1>
            {props.type === 'debited' ? "-" : "+"}
            {Dinero({
                  amount: Math.ceil(props.amount ? props.amount : 0),
                  precision: 4,
                  currency: 'USD',
              }).toFormat()
            }
          </div>
        </div>
      ),
    },
    {
      name: 'Date',
      selector: 'transaction_date',
      sortable: true,
      cell: (props: any) => (
        <div className={lineContainerClasses}>
          <div className={valueClasses}>
            <h1 className="col-label-mobile">Date:</h1>
            {props.date && 
             <h1>{format(new Date(props.date), "dd.MM.yyyy hh:mm")}</h1>
            }
          </div>
        </div>
      ),
    }
  ];

  const columnsFinancials : any[] = [
    {
      name: 'Type',
      selector: 'withdraw_via',
      sortable: true,
      accessor: 'withdraw_via',
      cell: (props: any) => (
        <div className={lineContainerClasses}>
          <div
            className={`capitalize ${valueClasses}`}
          >
            <h1 className="col-label-mobile">Type:</h1>
            {props.withdraw_via === "credits" ? "Blindspot Credits" : props.withdraw_via === 'wire' ? "Wire Transfer" : props.withdraw_via}
          </div>
        </div>
      ),
    },
    {
      name: 'Value',
      selector: 'withdraw_value',
      sortable: true,
      cell: (props: any) => (
        <div className={lineContainerClasses}>
          <div className={valueClasses}
          >
            <h1 className="col-label-mobile">Amount:</h1>
            {/* {props.type === 'debited' ? "-" : "+"} */}
            {Dinero({
                  amount: Math.ceil(props.withdraw_value ? props.withdraw_value : 0),
                  precision: 4,
                  currency: 'USD',
              }).toFormat()
            }
          </div>
        </div>
      ),
    },
    {
      name: 'Status',
      selector: 'withdraw_status',
      sortable: true,
      cell: (props: any) => (
        <div className={lineContainerClasses}>
          <div className={valueClasses}>
            <h1 className="col-label-mobile">Status:</h1>
            <h1 className={`capitalize cursor-pointer ${getStatusClases(props.withdraw_status != null ? props.withdraw_status : 'pending')} `}>
              {props.withdraw_status != null ? props.withdraw_status : 'Pending'}  
            </h1>
          </div>
        </div>
      ),
    },
    {
      name: 'Details',
      selector: 'withdraw_details',
      sortable: true,
      accessor: 'withdraw_details',
      cell: (props: any) => (
        <div className={lineContainerClasses}>
          {props.withdraw_via === 'credits' ? (
            <div
              className={`${valueClasses}`}
            >
              <h1 className="col-label-mobile">Details:</h1>
              <h1 className="mr-1">
                  {Dinero({
                        amount: (Math.ceil(props.withdraw_value ? props.withdraw_value : 0)) + 25/100 * (Math.ceil(props.withdraw_value ? props.withdraw_value : 0)),
                        precision: 4,
                        currency: 'USD',
                    }).toFormat()
                  }
              </h1>
              <h1 className="text-dark-300 mr-1">
                {" "} credits sent to:
                </h1>
              <h1 className="text-dark-400">{props.withdraw_details}</h1>
            </div>
          ) : (
            <div
              className={`${valueClasses}`}
            >
              <h1 className="col-label-mobile">Details:</h1>
              <h1 className="mr-1">
                  {Dinero({
                        amount: Math.ceil(props.withdraw_value ? props.withdraw_value : 0),
                        precision: 4,
                        currency: 'USD',
                    }).toFormat()
                  }
              </h1>
              <h1 className="text-dark-300 mr-1">
                {" "} added to your acount
                </h1>
            </div>
          )}
        </div>
      ),
    },
    {
      name: 'Date',
      selector: 'withdraw_datetime',
      sortable: true,
      cell: (props: any) => (
        <div className={lineContainerClasses}>
          <div className={valueClasses}>
            <h1 className="col-label-mobile">Date:</h1>
            {props.withdraw_datetime && 
             <h1>{format(new Date(props.withdraw_datetime), "dd.MM.yyyy hh:mm")}</h1>
            }
          </div>
        </div>
      ),
    },
    // {
    //   name: 'Invoice',
    //   selector: 'uuid_invoice',
    //   sortable: true,
    //   cell: (props: any) => (
    //     <div className={lineContainerClasses}>
    //       <div className={valueClasses}>
    //         <h1 className="col-label-mobile">Invoice:</h1>
    //         <Download set="broken"/>
    //       </div>
    //     </div>
    //   ),
    // }
  ];

  const columnsUsers : any[] = [
    {
      name: 'User',
      selector: 'referee_email',
      sortable: true,
      accessor: 'referee_email',
      cell: (props: any) => (
        <div className={lineContainerClasses}>
          <div
            className={`cursor-pointer ${valueClasses}`}
          >
            <h1 className="col-label-mobile">User:</h1>
            {props.user}
          </div>
        </div>
      ),
    },
    {
      name: 'Status',
      selector: 'referee_status',
      sortable: true,
      cell: (props: any) => (
        <div className={lineContainerClasses}>
          <div className={valueClasses}>
            <h1 className="col-label-mobile">Status:</h1>
            <h1 className={getStatusClases(props.status)}>
              {props.status}  
            </h1>
          </div>
        </div>
      ),
    },
    {
      name: 'Registered at',
      selector: 'registered_at',
      sortable: true,
      cell: (props: any) => (
        <div className={lineContainerClasses}>
          <div className={valueClasses}>
            <h1 className="col-label-mobile">Registered at:</h1>
            {props.registered_at && 
             <h1>{format(new Date(props.registered_at), "dd.MM.yyyy hh:mm")}</h1>
            }
          </div>
        </div>
      ),
    },
    {
      name: 'Activated at',
      selector: 'activated_at',
      sortable: true,
      cell: (props: any) => (
        <div className={lineContainerClasses}>
          <div className={valueClasses}>
            <h1 className="col-label-mobile">Activated at:</h1>
            {props.activated_at ?
             <h1>{format(new Date(props.activated_at), "dd.MM.yyyy hh:mm")}</h1>
              :
             <h1 className="text-dark-300">Not yet activated ( at least a 500$ campaign )</h1>
            }
          </div>
        </div>
      ),
    },
  ];

  const setDisplayType = async (table: any) => {
    if (table === 'users') {
      setColumns(columnsUsers);
      setTableData(usersTable);
    }
    if (table === 'transactions') {
      setColumns(columnsTransactions);
      setTableData(transactionsTable);
    }
    if (table === 'financials') {
      setColumns(columnsFinancials);
      setTableData(financialsTable);
    }
    setSelectedTabel(table);
  }

  const handleSort = async (column: any, sortDirection: any) => {
    let localList = [...tablesList];
    if (column && column.selector) {
      const tabel = localList.filter(el => el.value === selectedTable)[0];
      if (tabel) {
        tabel.sort.order_by = column.selector;
        tabel.sort.order_type = sortDirection;
      }
      const index = localList.indexOf(tabel);
      if(index > -1) {
        localList[index] = tabel;
      }
      setTablesList(localList);
    }
   }

   const hadleFilter = async (filter_value: string, filter_by: string) => {
    let localList = [...tablesList];
    if (filter_value && filter_by) {
      const tabel = localList.filter(el => el.value === selectedTable)[0];
      if (tabel) {
        if (filter_value !== 'all') {
          setUsedFilters(true);
          tabel.filter.filter_value = filter_value;
          tabel.filter.filter_by = filter_by;
        } else {
          setUsedFilters(false);
          tabel.filter.filter_value = null;
          tabel.filter.filter_by = null;
        }
      }
      const index = localList.indexOf(tabel);
      if(index > -1) {
        localList[index] = tabel;
      }
      setTablesList(localList);
    }
   }

   const handleRowsPerPage = async (rows: any) => {
     let localList = [...tablesList];
      if (rows) {
        const tabel = localList.filter(el => el.value === selectedTable)[0];
        if (tabel) {
          tabel.pagination.limit = rows;
          tabel.pagination.skip = 0;
        }
        const index = localList.indexOf(tabel);
        if(index > -1) {
          localList[index] = tabel;
        }
      setTablesList(localList);
      }
   }

   const handleChangePage = async (page: any) => {
    let localList = [...tablesList];
      if (page) {
        const tabel = localList.filter(el => el.value === selectedTable)[0];
        if (tabel) {
          tabel.pagination.skip = page - 1;
        }
        const index = localList.indexOf(tabel);
        if(index > -1) {
          localList[index] = tabel;
        }
      setTablesList(localList);
      }
   }

   const getTotalRowsTabel = () => {
    switch (selectedTable) {
      case 'users':
        return totalRowsUsers;
      case 'transfers':
        return totalRowsTrans;
      case 'financials':
        return totalRowsFinancials;
    }
   }

  return (
    <>
    <TablesActions
      tablesList={tablesList}
      selectTable={(table) => setDisplayType(table)}
      applyFilter={(filter_value, filter_by) => hadleFilter(filter_value, filter_by)}
      selectedTable={selectedTable}
      statusUsers={statusUsers}
    />
    {!loader ? (
      <div className="bg-dark-200 rounded-20">
        {((tableData && tableData.length > 0) || usedFilters === true) ? 
        <DataTable
          noHeader={true}
          className="table-simulate"
          pagination={true}
          paginationPerPage={10}
          onSort={handleSort}
          sortServer
          columns={columns}
          data={tableData}
          paginationServer
          onChangeRowsPerPage={handleRowsPerPage}
          onChangePage={handleChangePage}
          paginationTotalRows={getTotalRowsTabel()}
        /> :
        <NoDataTable selectedTable={selectedTable} />
        }
      </div>
    ) : 
    (
      <div className="bg-dark-200 rounded-20 flex flex-row items-center justify-center min-h-[350px]">
          <PulseLoader color={'#eeeff0'} size={20} loading={true} />
      </div>
    )}
    </>
  );
};
export default Tables;
